// Renderiza a etiqueta de credenciamento como HTML no próprio cliente e a
// imprime via iframe. Diferente de imprimir um PDF-em-iframe, isto NÃO depende
// do plugin de PDF do Chrome nem da configuração "abrir/baixar PDFs" — o Chrome
// sempre imprime HTML. Também não depende do endpoint de etiqueta do backend:
// os dados (QR, nome, cor do cordão) já estão no objeto participante.

function escapeHtml(valor) {
    return String(valor == null ? '' : valor).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
}

export default function imprimirEtiquetaHtml(participante, opcoes) {
    const p = participante || {};
    const o = opcoes || {};
    // Tamanho da etiqueta ajustável por fora (ex.: query param), sem mexer no código.
    const largura = Number(o.largura) > 0 ? Number(o.largura) : 62;
    const altura = Number(o.altura) > 0 ? Number(o.altura) : 40;
    const nome = escapeHtml(p.nome);
    const qr = p.qrCode || '';
    const corNome = escapeHtml(p.nomeCorCordao || p.classificacao || '');

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.left = '-10000px';
    iframe.style.top = '0';
    iframe.style.width = '400px';
    iframe.style.height = '600px';
    iframe.style.border = '0';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(
        '<!doctype html><html><head><meta charset="utf-8">' +
            '<style>' +
            '@page { size: ' + largura + 'mm ' + altura + 'mm; margin: 0; }' +
            'html,body{margin:0;padding:0;-webkit-print-color-adjust:exact;print-color-adjust:exact;}' +
            '.etq{width:' + largura + 'mm;box-sizing:border-box;font-family:Arial,Helvetica,sans-serif;}' +
            '.row{display:flex;align-items:center;padding:2mm;}' +
            '.qr{width:28mm;height:28mm;flex:0 0 auto;}' +
            '.info{margin-left:2mm;overflow:hidden;}' +
            '.nome{font-size:12pt;font-weight:bold;line-height:1.1;word-break:break-word;}' +
            '.cor-nome{font-size:8pt;text-transform:uppercase;margin-top:1mm;}' +
            '</style></head><body>' +
            '<div class="etq"><div class="row">' +
            (qr ? '<img class="qr" src="data:image/PNG;base64,' + qr + '" alt="QR" />' : '') +
            '<div class="info"><div class="nome">' + nome + '</div>' +
            '<div class="cor-nome">' + corNome + '</div></div>' +
            '</div></div>' +
            '</body></html>'
    );
    doc.close();

    const win = iframe.contentWindow;

    function limpar() {
        setTimeout(function () {
            if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        }, 1000);
    }

    function imprimir() {
        win.focus();
        win.print();
        setTimeout(limpar, 3000); // fallback caso onafterprint não dispare
    }

    win.onafterprint = limpar;

    // Espera a imagem do QR pintar antes de imprimir.
    const img = doc.querySelector('img.qr');
    if (img && !img.complete) {
        img.onload = imprimir;
        img.onerror = imprimir;
    } else {
        setTimeout(imprimir, 150);
    }
}
